import {
  Divider,
  Input,
  Select,
  Icon,
  Button as AntdButton,
  Tooltip
} from "antd";
import React, { useEffect, useMemo, useRef, useState } from "react";
import moment from "moment";
import * as R from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Button from "../../Button";
import {
  updateCandidateBaseByID,
  UPDATE_CANDIDATE_BY_ID
} from "../../../store/actions/candidates";
import { isLoading } from "../../../utils/actions";

import styled from "styled-components/macro";

const MAX_LENGTH = 5000;

const Content = styled.div`
  padding: 32px 20px 20px 20px;
`;

const EditedBy = styled.span`
  margin-left: 10px;
  color: ${({ theme }) => theme["@gray-50"]};
  font-size: 11px;
`;

const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

const Wrapper = styled.div`
  align-items: baseline;
  margin-left: 2px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
`;

const TextArea = styled(Input.TextArea)`
  background: white !important;
  &.ant-input[disabled] {
    border: none;
    color: ${({ theme }) => theme["@gray-80"]};
    cursor: default;
  }
`;

const MetadataNotes = ({ setDisabled }) => {
  const { t } = useTranslation();
  const ref = useRef();
  const dispatch = useDispatch();
  const [enabled, setEnabled] = useState(false);
  const { companyMetadataNotes = [], id } = useSelector(
    ({ candidates }) => candidates.selected
  );
  const users = useSelector(({ company }) => company.users);
  const loading = useSelector(state =>
    isLoading(UPDATE_CANDIDATE_BY_ID, state)
  );
  const sortedNotes = useMemo(
    () =>
      R.pipe(
        R.sortBy(R.prop("createdAt")),
        R.reverse
      )(companyMetadataNotes),
    [companyMetadataNotes]
  );

  //TODO fix this logic
  const [index, setIndex] = useState(0);
  const note = sortedNotes[index];
  const [text, setText] = useState(R.propOr("", "text", note));

  const user = useMemo(
    () =>
      R.find(R.propEq("id", R.propOr("", "idUser", sortedNotes[index])), users),
    [index, sortedNotes, users]
  );

  useEffect(() => {
    setText(R.propOr("", "text", note));
  }, [note]);

  useEffect(() => {
    if (enabled && ref.current) ref.current.focus();
  }, [enabled]);

  useEffect(() => {
    if (sortedNotes.length > 0) setIndex(0);
  }, [sortedNotes]);

  const handleSave = () => {
    setEnabled(false);
    dispatch(
      updateCandidateBaseByID({
        id,
        formData: {
          companyMetadataNotes: R.append({ text }, sortedNotes)
        }
      })
    );
  };

  return (
    <Content>
      {sortedNotes.length > 0 && (
        <>
          <Wrapper>
            <div>
              <Icon type="clock-circle" />
              <span style={{ marginRight: 10, marginLeft: 10 }}>
                {t("opportunity:process.candidateDetails.historyTitle")}
              </span>
              <Select
                style={{ width: 370, border: 0 }}
                value={index}
                onChange={value => {
                  setIndex(value);
                  setEnabled(false);
                }}
              >
                {sortedNotes.map(({ createdAt }, index) => (
                  <Select.Option key={index} value={index}>
                    {`${
                      index === 0
                        ? t("opportunity:process.candidateDetails.lastUpdate")
                        : ``
                    } ${moment(createdAt).format(
                      `DD/MM/YYYY [${t(
                        "opportunity:process.candidateDetails.at"
                      )}] HH:mm:ss`
                    )}`}
                  </Select.Option>
                ))}
              </Select>
              {user && (
                <EditedBy>
                  {t("opportunity:process.candidateDetails.editedBy", {
                    user: user.name
                  })}
                </EditedBy>
              )}
            </div>
            <div>
              <Tooltip
                placement="left"
                title={t("opportunity:process.candidateDetails.commentEdit")}
              >
                <AntdButton
                  icon="edit"
                  type={enabled ? "primary" : "default"}
                  shape="circle"
                  onClick={() => setEnabled(prevState => !prevState)}
                />
              </Tooltip>
            </div>
          </Wrapper>
          <Divider style={{ margin: "20px 0px 20px" }} />
        </>
      )}
      <TextArea
        onFocus={() => setDisabled(true)}
        onBlur={() => setDisabled(false)}
        rows={12}
        style={{ resize: "none" }}
        onChange={ev => setText(ev.target.value)}
        value={text}
        disabled={!enabled && sortedNotes.length > 0}
        ref={ref}
        placeholder={t("opportunity:process.candidateDetails.placeholder")}
      />
      <WrapperButton>
        <Button
          onClick={handleSave}
          type="primary"
          disabled={
            loading ||
            R.length(text) === 0 ||
            R.length(text) > MAX_LENGTH ||
            text === R.propOr("", "text", note)
          }
          loading={loading}
        >
          {t("global:save")}
        </Button>
      </WrapperButton>
    </Content>
  );
};

export default MetadataNotes;
